import GenericModel from '../generic-model';
import HeightEquipment from '../height-equipment';
import LoggedAction from '../logged-action';
import Employee from './employee';

export default class ProductPlacement extends GenericModel {
  productPlacementType?: string;

  placementExtraDescription?: string;

  placementEarliestDate?: Date;

  heightEquipment?: HeightEquipment;

  extraHoogwerker?: boolean;

  extraHoogwerkerDone?: boolean;

  extraHoogwerkerDescription?: string;

  extraHoogwerkerDeadline?: Date;

  extraHoogwerkerEmployee?: Employee;

  siteAccessible?: boolean;

  siteAccessibleDescription?: string;

  placeASAP?: boolean;

  actualPlacementDate?: Date;

  actualPlacementDateConfirmed?: boolean;

  installerHourBudget?: number;

  installerMinuteBudget?: number;

  kilometersTo?: number;

  installerInfo?: string;

  installerFeedback?: string;

  actualPlacementExtraDescription?: string;

  executionComplete?: boolean;

  executionCompleteInfo?: string;

  parkingBan?: boolean;

  parkingBanDone?: boolean;

  extraInfoParkingBan?: string;

  parkingBanDeadline?: Date;

  parkingBanEmployee?: Employee;

  placers?: Employee[];

  needSiteVisit?: boolean;

  extraInfoNeedSiteVisit?: boolean;

  needExtraSupplier?: boolean;

  needExtraSupplierDone?: boolean;

  extraInfoNeedExtraSupplier?: string;

  extraSupplierDeadline?: Date;

  extraSupplierEmployee?: Employee;

  needExtraMaterials?: boolean;

  needExtraMaterialsDone?: boolean;

  extraInfoNeedExtraMaterials?: string;

  extraMaterialsDeadline?: Date;

  extraMaterialsEmployee?: Employee;

  executionDate?: Date;

  executionTime?: string;

  extraInfoSite?: string;

  placementInfoInvoice?: string;

  placedRegistration?: LoggedAction;

  constructor() {
    super();
    this.extraHoogwerkerDone = false;
    this.parkingBanDone = false;
    this.needExtraSupplierDone = false;
    this.needExtraMaterialsDone = false;
  }
}
